import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const appUrl = 'https://app.tuasistencia.com.co';
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Cómo funciona', id: 'como-funciona' },
    { label: 'Características', id: 'caracteristicas' },
    { label: 'Planes', id: 'planes' },
    { label: 'FAQ', id: 'faq' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <button
            type="button"
            aria-label="Ir al inicio"
            className="flex items-center cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img
              src={`${process.env.PUBLIC_URL}/tuasistencia.png`}
              alt="Logo de TuAsistencia"
              className="h-10 w-auto"
            />
          </button>

          {/* Desktop Navigation */}
          <nav aria-label="Navegación principal" className="hidden lg:flex items-center space-x-2">
            {navItems.map((item, index) => (
              <React.Fragment key={item.id}>
                <button
                  type="button"
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-700 hover:text-blue-600 hover:bg-blue-50 font-medium transition-all duration-200 px-4 py-2 rounded-lg"
                >
                  {item.label}
                </button>
                {index < navItems.length - 1 && (
                  <div className="w-px h-4 bg-gray-300"></div>
                )}
              </React.Fragment>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center space-x-3">
            <Button
              variant="ghost"
              onClick={() => window.location.href = appUrl}
              className="font-medium hover:bg-gray-100 px-5 py-2"
            >
              Iniciar sesión
            </Button>
            <Button
              onClick={() => window.location.href = appUrl}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2 shadow-sm hover:shadow-md transition-all"
            >
              Empezar gratis
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="lg:hidden p-2 text-gray-700 hover:text-blue-600 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div id="mobile-menu" className="lg:hidden py-4 border-t border-gray-100">
            <nav aria-label="Navegación principal" className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200 py-2"
                >
                  {item.label}
                </button>
              ))}
              <div className="pt-4 space-y-3 border-t border-gray-100">
                <Button
                  variant="outline"
                  onClick={() => {
                    window.location.href = appUrl;
                    setMobileMenuOpen(false);
                  }}
                  className="w-full font-medium"
                >
                  Iniciar sesión
                </Button>
                <Button
                  onClick={() => {
                    window.location.href = appUrl;
                  }}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium"
                >
                  Empezar gratis
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
